import { Button, Flex, Text } from '@chakra-ui/react';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

export const IconRequestContainer = (props: Partial<ComponentProps<typeof Flex>>) => {
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.iconsMenu' });
  const iconRequestText = t('iconRequest');

  return (
    <Flex justify='space-between' alignItems='center' p={2} bg={'gray.50'} borderRadius='4px' {...props}>
      <Text fontSize='xs' fontWeight={'400'}>
        {t('iconRequestQuestion')}
      </Text>
      <Button
        size='xs'
        background={'action-green.500'}
        variant='action'
        aria-label={iconRequestText}
        data-testid={'request-icon-button'}
        p={4}
      >
        <Text as='span' color={'white'} fontSize='xs' fontWeight={'400'}>
          {iconRequestText}
        </Text>
      </Button>
    </Flex>
  );
};
